import React, { useState, useEffect, Fragment, useRef } from "react";

import { ReactComponent as PersonnIcon } from "../../../assets/images/icons/person.svg";
import { ReactComponent as DateIcon } from "../../../assets/images/icons/date.svg";
import { ReactComponent as NumberIcon } from "../../../assets/images/icons/number.svg";
import { ReactComponent as CheckMark } from "../../../assets/images/icons/CheckMark.svg";
import CustomDrawer from "../../UniversalComponents/CustomDrawer";
import { pushAlert } from "../../../utils/alertSlice";
import { useDispatch } from "react-redux";
import { ReactComponent as ClosePopUpIcn } from "../../../assets/images/closePopUpIcn.svg";
import { ReactComponent as DollarIcon } from "../../../assets/images/icons/DollarIcon.svg";
import { ReactComponent as Percentage } from "../../../assets/images/icons/Percentage.svg";
import { ReactComponent as EmailTextIcon } from "../../../assets/images/icons/EmailTextIcon.svg";
import { ReactComponent as HyperlinkIcon } from "../../../assets/images/icons/HyperlinkIcon.svg";
import { ReactComponent as SortTextIcon } from "../../../assets/images/icons/SortTextIcon.svg";
import { ReactComponent as LongTextIcon } from "../../../assets/images/icons/LongText.svg";
import { ReactComponent as URLIcon } from "../../../assets/images/icons/UrlIcon.svg";
import { ReactComponent as DateTimeIcon } from "../../../assets/images/icons/DatendTime.svg";
import { ReactComponent as SideArrow } from "../../../assets/images/icons/BackIcon.svg";
import CustomSVG from "../../UniversalComponents/CustomSVG";
import BasicSelect from "../../Task/BasicSelect";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import { formatNegativeNumber, formatTextValue } from "../../../utils/utilityFunctions/stringUtility";
import { mySpaceFieldOptionsAddUpdate } from "../../../utils/api/mySpaceApi";
import { query } from "@firebase/firestore";
import { addUpdateBillingOption } from "../../../utils/api/billingApi";
import { useAddUpdateGlobalListMutation, useGetGlobalDropdownQuery } from "../../ActivityLogs/AuditLogAPIS";
import SelectComponent from "../../UniversalComponents/SelectComponent";
import { Dialog } from "@mui/material";
import icon from "../../../assets/images/linkIcon.svg";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import Button from "../../UniversalComponents/DefaultButton";
import ChoiceField from "./ChoiceField";

const AddFieldDrawer = ({
  open,
  onClose,
  ExtraFieldAddHeader = () => {},
  EditFieldData,
  handleDeleteOption,
  headerData = [],
  isMySpace = false,
  handleUpdateTableColumn = () => {},
  isBilling = false,
}) => {
  const options = [
    // { label: `Dropdown`, value: "dropdown", svg: CirclePattleIcon },
    // { label: "List Box", value: "Listbox", svg: ListBoxx },
    // { label: "Multi-Select", value: "multiple", svg: Multiselect },
    // { label: "Text", value: "text", svg: Text },
    { label: "Email", value: "text", svg: EmailTextIcon },
    { label: "Short Text", value: "text", svg: SortTextIcon },
    { label: "Long Text", value: "text", svg: LongTextIcon },
    { label: "Hyperlink", value: "text", svg: HyperlinkIcon },
    { label: "URL", value: "text", svg: URLIcon },
    { label: "Number", value: "number", svg: NumberIcon },
    { label: "Currency", value: "number", svg: DollarIcon },
    { label: "Percentage", value: "number", svg: Percentage },
    { label: "Date", value: "date", svg: DateIcon },
    { label: "Date & Time", value: "date", svg: DateTimeIcon },
    { label: `Choice`, value: "choice", svg: CheckMark },
    { label: "Person", value: "person", svg: PersonnIcon },
  ];

  console.log(
    EditFieldData?.field_type === "dropdown" && EditFieldData?.selectedOption === "Choice",
    "EditFieldData78685"
  );
  // const [selectedType, setSelectedType] = useState(EditFieldData?.selectedOption?.type ?? "Number");
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const [useSeparator, setUseSeparator] = useState(EditFieldData?.separators ?? false);
  // const [textSelectedOption, setTextSelectedOption] = useState();
  const [isTextDropdownOpen, setIsTextDropdownOpen] = useState(false);

  const [formData, setFormData] = useState({
    symbol: EditFieldData?.symbol || false,
  });

  const [decimalPlaces, setDecimalPlaces] = useState(null);

  const [selectedNegativeFormat, setSelectedNegativeFormat] = useState("minus");
  const [isCloned, setIsCloned] = useState(false);
  // const [isTime, setIsTime] = useState(EditFieldData?.timeDisplay ?? true);

  const {
    data: globalDropdownData,
    isLoading: globalDropdownLoading,
    isFetching: globalDropdownFetching,
    isError: globalDropdownError,
    error: globalDropdownErrorData,
    isSuccess: globalDropdownSuccess,
    refetch: getGlobalDropdownRefetch,
  } = useGetGlobalDropdownQuery(undefined, {
    // skip: !open || !(selectedOption?.label === "Choice" && isCloned),
    // refetchOnFocus: false,
    // refetchOnReconnect: false,
    // refetchOnMount: false,
    // refetchOnMountOrArgChange: false,
  });

  const negativeNumberFormats = [
    {
      format: "minus",
      value: -1234.12,
    },
    {
      format: "red",
      value: -1234.12,
    },
    // {
    //  format: "red-minus",
    //   value: -1234.1
    // },
    {
      format: "parentheses",
      value: -1234.12,
    },
    {
      format: "red-parentheses",
      value: -1234.12,
    },
  ];

  useEffect(() => {
    if (selectedOption?.label === "Currency") {
      setUseSeparator(true);
    }
    if (selectedOption?.label === "Number") {
      setUseSeparator(false);
    }
  }, [selectedOption?.label]);

  const optionListCurrency = [
    { label: "₹", value: "INR" },
    { label: "$", value: "USD" },
    { label: "€", value: "EUR" },
    { label: "£", value: "GBP" },
    { label: "¥", value: "JPY" },
  ];

  const handleCurrencyChange = (e) => {
    const { name, value } = e.target;

    const selectedOption = optionListCurrency.find((option) => option.value === value);

    setFormData((prevFormData) => ({
      ...prevFormData,
      symbol: selectedOption ? selectedOption?.label : value,
      [name]: selectedOption ? selectedOption?.label : value,
    }));
  };

  useEffect(() => {
    if (EditFieldData?.selectedOption) {
      console.log(EditFieldData, options, "EditFieldDataselectedOption");

      const match = options.find((option) => option.label === EditFieldData.selectedOption);
      if (match) setSelectedOption(match);
      console.log("matchingOption", match);
    }

    if (EditFieldData?.decimalPlaces) {
      setDecimalPlaces(EditFieldData?.decimalPlaces);
    }
    if (EditFieldData?.separators) {
      setUseSeparator(EditFieldData?.separators);
    }
    if (EditFieldData?.symbol) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        symbol: EditFieldData?.symbol,
      }));
    }
    if (EditFieldData?.negativeFormat) {
      setSelectedNegativeFormat(EditFieldData?.negativeFormat);
    }
    // if (EditFieldData?.textSelectedOption) {
    //   setTextSelectedOption({ label: EditFieldData?.textSelectedOption });
    // }
    // if (EditFieldData?.timeDisplay) {
    //   setIsTime(EditFieldData?.timeDisplay);
    // }
  }, [EditFieldData]);

  console.log("EditFieldDat.selectedOptionsaumya", EditFieldData?.selectedOption);
  console.log("options", options);

  // useEffect(() => {
  //   if (EditFieldData) {
  //     setDecimalPlaces({EditFieldData ? decimalPlaces?.decimalPlaces :  0 });
  //   }
  // }, [selectedType]);

  const [inputValue, setInputValue] = useState("");
  const [shadowColor, setShadowColor] = useState("");
  const [inputVisible, setInputVisible] = useState(false);
  const [allowMultiple, setAllowMultiple] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEmptyOption, setIsEmptyOption] = useState(false);
  // const [inputValue, setInputValue] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [choiceToDelete, setChoiceToDelete] = useState(null);

  const [isMultiPerson, setIsMultiPerson] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedGlobalList, setSelectedGlobalList] = useState(null);
  const [isCopyToGlobalList, setIsCopyToGlobalList] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState("");
  const [extraFieldData, setExtraFieldData] = useState({
    field_name: "",
    field_label: "",
    field_options: [],
    field_type: "",
    field_description: "",
    field_text_type: "",
  });

  const [copyToGlobalListFormData, setCopyToGlobalListFormData] = useState({
    globalListname: "",
    ChoiceValues: [],
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const editFields = {
      field_name: EditFieldData?.field_name || "",
      field_label: EditFieldData?.field_label || "",
      field_options: EditFieldData?.field_options || [],
      field_type: EditFieldData?.field_type
        ? EditFieldData?.field_type === "dropdown" || EditFieldData?.field_type === "multiselect"
          ? "choice"
          : EditFieldData?.field_type
        : options[0].value,
      field_description: EditFieldData?.field_description || "",
      fieldId: EditFieldData?.id || EditFieldData?.field_id || "",
      // field_text_type: EditFieldData?.textSelectedOption || "",
    };

    setExtraFieldData(editFields);
    // setSelectedOption(options.find((option) => option.value === editFields.field_type));

    if (EditFieldData?.field_type === "multiselect") setAllowMultiple(true);
  }, [EditFieldData]);

  const handleFieldChange = (field, e) => {
    setErrors((prev) => ({ ...prev, field_name: "" }));
    const newValue = e.target.value;
    setExtraFieldData((prevState) => ({
      ...prevState,
      [field]: newValue,
      ...(field === "field_label" && { field_name: newValue }),
    }));
  };

  const ExtraFieldSaveHeader = async () => {
    let updatedFieldData;
    if (!extraFieldData.field_label?.trim()) {
      setErrors((prev) => ({ ...prev, field_name: "mandatory" }));
      dispatch(pushAlert({ visible: true, message: "Missing field label", type: "danger" }));
      return;
    }

    if (
      headerData?.some(
        (item) => item.label?.trim().toLowerCase() === extraFieldData.field_name?.trim().toLowerCase()
      ) &&
      !EditFieldData
    ) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Field with this name already exists",
          type: "danger",
        })
      );
      return;
    }

    if (extraFieldData.field_type === "choice" && !extraFieldData.field_options.length) {
      dispatch(pushAlert({ visible: true, message: "Add at least one option", type: "danger" }));
      return;
    }

    if (inputValue.trim() !== "") {
      dispatch(
        pushAlert({
          visible: true,
          type: "warning",
          message: "Your last option is not saved",
        })
      );
      return;
    }

    const updatedData = updatedFieldData ? updatedFieldData : extraFieldData;

    const extraFieldPost = {
      // id: updatedData?.id,
      field_type: updatedData?.field_type,
      field_name: EditFieldData?.field_value ? EditFieldData?.field_value : updatedData?.field_name,
      field_label: updatedData?.field_label,
      // field_display: updatedData?.field_display,
      field_description: updatedData?.field_description,
      meta: {
        numberFormat: {
          selectedOption: selectedOption?.label,
          separators: useSeparator,
          decimalPlaces: decimalPlaces,
          symbol: formData["symbol"],
          negativeFormat: selectedNegativeFormat,
        },
        textFormat: {
          textSelectedOption: selectedOption?.label,
        },
        dateTimeFormat: {
          timeDisplay: selectedOption?.label,
        },
      },
    };

    if (updatedData?.field_type === "choice") {
      extraFieldPost.field_options = updatedData?.field_options;
      if (allowMultiple) extraFieldPost.field_type = "multiselect";
      else extraFieldPost.field_type = "dropdown";
    }

    if (updatedData?.field_type === "person" && isMultiPerson) {
      extraFieldPost.field_type = "multi_person";
    }

    if (EditFieldData?.field_label && isMySpace) {
      handleUpdateTableColumn({ ...extraFieldPost, fieldId: extraFieldData?.fieldId });
    } else {
      ExtraFieldAddHeader(extraFieldPost, EditFieldData ? true : false);
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  const handleOptionSelect = (option) => {
    // setSelectedOption({ label: option.label, svg: option?.svg, value: option.value });
    setSelectedOption(option);
    setExtraFieldData((prevState) => ({
      ...prevState,
      field_type: option.value,
      field_options: [],
    }));
    setIsDropdownOpen(false);
  };

  const removeChoiceApi = (choice) => {
    setChoiceToDelete(choice);
    setShowConfirmation(true);
  };

  // console.log(typeof handleDeleteOption, "onDeleteOption");

  const handleConfirmDelete = () => {
    if (choiceToDelete) {
      handleDeleteOption(choiceToDelete, EditFieldData?.field_value);
    }
    setShowConfirmation(false);
    setChoiceToDelete(null);
  };

  const RenderNumberFormat = () => {
    return (
      <div>
        {(selectedOption?.label === "Number" ||
          selectedOption?.label === "Percentage" ||
          selectedOption?.label === "Currency") && (
          <div className="flex flex-col gap-4">
            <div className="flex flex-row gap-2">
              <div className="flex flex-col font-400 text-sm w-full gap-4">
                <div className="flex flex-row gap-2 w-[180px] items-center">
                  <label className="text-434852 font-poppins text-sm font-normal whitespace-nowrap">
                    Decimal Places
                  </label>

                  <input
                    type="number"
                    // autoFocus={true}
                    min={0}
                    max={2}
                    className="h-8 border-[#DFE2E5] rounded-md capitalize border cursor-pointer focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 flex w-full items-center  justify-between "
                    value={decimalPlaces ? decimalPlaces : 0}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (!isNaN(value) && value >= 0 && value <= 2) {
                        setDecimalPlaces(value);
                      }
                    }}
                  />
                </div>
                {(selectedOption?.label === "Currency" || selectedOption?.label === "Number") && (
                  <div className="text-535252 font-500 items-center gap-2 flex w-full justify-between">
                    <input
                      type="checkbox"
                      id="checkbox2"
                      className="items-center appearance-none w-4 h-4 border border-[#D9D9D9] rounded-sm focus:outline-white focus:ring-0 cursor-pointer checked:bg-[#2999BC] checked:border-[#2999BC] checked:after:text-white checked:after:text-sm checked:after:absolute checked:after:left-1 checked:after:top-0.5"
                      checked={useSeparator}
                      onChange={(e) => setUseSeparator(e.target.checked)}
                    />
                    <span className="text-[#434852] font-normal text-sm font-normal w-full ">
                      Use 1000 Separator(,)
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/*Type=currency */}

            {selectedOption?.label === "Currency" && (
              <div>
                <label className="text-434852 font-poppins text-sm font-normal mb-2 block">Symbol</label>
                <BasicSelect
                  options={optionListCurrency || []}
                  place
                  name="currencyType"
                  selectedOptions={optionListCurrency?.filter((option) => option?.label === formData.symbol)}
                  onChange={handleCurrencyChange}
                  onClick={() => {}}
                  type={"select"}
                  size={"medium"}
                  label="Currency Type"
                />
              </div>
            )}

            {(selectedOption?.label === "Currency" || selectedOption?.label === "Number") && (
              <div>
                <label className="text-[#434852] font-poppins text-sm font-normal mb-2 block">Negative Numbers</label>
                <div className="flex flex-row w-full gap-1">
                  {negativeNumberFormats.map((item, index) => {
                    return (
                      <div
                        className={`px-2 py-1 border rounded-md font-normal min-w-[60px] max-w-[60px] flex flex-row text-sm justify-center cursor-pointer transition ${
                          selectedNegativeFormat === item.format ? "border-[#1D4469]" : "border-[#D2DAE1]"
                        }`}
                        onClick={() => {
                          setSelectedNegativeFormat(item.format);
                        }}
                        key={index}
                      >
                        {formatNegativeNumber(
                          item.value,
                          item.format,
                          selectedOption?.label,
                          decimalPlaces,
                          useSeparator,
                          formData?.symbol
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // UPDATE OPTIONS
  const handleFieldOptionUpdate = async (data) => {
    try {
      let body = {
        optionId: data?.uuid,
        option: {
          value: data?.value,
        },
      };

      if (data?.color_code) {
        body = {
          optionId: data?.uuid,
          option: {
            value: data?.value,
            color_code: data?.color_code,
          },
        };
      }

      let response;
      if (isBilling) {
        response = await addUpdateBillingOption({
          body: { id: data?.uuid, value: data?.value, color: data?.color_code },
          query: { field_name: EditFieldData?.field_name },
        });
      } else {
        response = await mySpaceFieldOptionsAddUpdate({ body, params: { fieldId: data?.field_id } });
      }

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  // ADD OPTIONS
  const handleFieldOptionAdd = async (optionData) => {
    try {
      let body = {
        option: {
          value: optionData.value,
        },
      };

      if (optionData?.color_code) {
        body = {
          option: {
            value: optionData.value,
            color_code: optionData.color_code,
          },
        };
      }

      let response;
      if (isBilling) {
        response = await addUpdateBillingOption({
          body: { value: optionData.value, color: optionData.color_code },
          query: { field_name: EditFieldData?.field_name },
        });
      } else {
        response = await mySpaceFieldOptionsAddUpdate({ body, params: { fieldId: EditFieldData?.id } });
      }

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
        getGlobalDropdownRefetch();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleGlobalListSelect = (val) => {
    const selectedValues = val[0]?.values || [];
    setSelectedGlobalList(selectedValues);
    setExtraFieldData((prev) => ({
      ...prev,
      field_options: selectedValues.map((item) => ({ value: item.label, color_code: item.color_code, id: item.id })),
    }));
  };

  const handleCloneToggle = () => {
    setIsCloned((prev) => {
      const newValue = !prev;
      if (!newValue) {
        setSelectedGlobalList([]);
        setExtraFieldData((prevData) => ({
          ...prevData,
          field_options: [],
        }));
      }
      return newValue;
    });
  };

  const [
    saveGlobalDropdown,
    {
      data: saveCopytoGlobalData,
      isLoading: copyToGlobalDataLoading,
      isSuccess: copyToGlobalDataSuccess,
      isError: copyToGlobalDataIsError,
      error: copyToGlobalDataError,
    },
  ] = useAddUpdateGlobalListMutation();

  const handleGlobalListDialogClose = () => {
    setIsCopyToGlobalList(false);
    setCopyToGlobalListFormData({ globalListname: "", ChoiceValues: [] });
    setIsDuplicate("");
  };

  const handleCheckDuplicateList = (listName) => {
    const isDuplicateName = globalDropdownData?.data?.some(
      (item) => item.name.toLowerCase() === listName.toLowerCase()
    );
    if (isDuplicateName) {
      setIsDuplicate("This Global name is already exists. Please enter a different name ");
    } else {
      setIsDuplicate("");
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setCopyToGlobalListFormData((prev) => ({
      ...prev,
      globalListname: value,
    }));
    handleCheckDuplicateList(value);
  };

  const handleCopyToGlobalSave = () => {
    if (isDuplicate || !copyToGlobalListFormData.globalListname.trim()) return;

    const payload = {
      label: copyToGlobalListFormData.globalListname.trim(),
      name: copyToGlobalListFormData.globalListname.trim(),
      values: extraFieldData.field_options.map((opt) => ({
        label: opt.value,
        color: opt.color_code || null,
      })),
    };

    saveGlobalDropdown(payload);
  };

  useEffect(() => {
    if (copyToGlobalDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (copyToGlobalDataSuccess) {
      dispatch(
        pushAlert({
          message: saveCopytoGlobalData?.message || "List saved successfully",
          type: saveCopytoGlobalData?.success ? "success" : "danger",
          visible: true,
        })
      );
      getGlobalDropdownRefetch();

      if (saveCopytoGlobalData?.success) {
        setCopyToGlobalListFormData({
          globalListname: "",
          ChoiceValues: [],
        });
        handleGlobalListDialogClose();
      }
    }

    if (copyToGlobalDataIsError) {
      dispatch(
        pushAlert({
          message: copyToGlobalDataError?.data?.message || "Failed to save list",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [copyToGlobalDataLoading, copyToGlobalDataSuccess, copyToGlobalDataIsError]);

  return (
    <CustomDrawer open={open} onClose={handleClose} showSubDrawer={selectedOption?.label} inverseSubDrawer>
      <div className="w-full h-full flex flex-col relative overflow-hidden no-scrollbar" id="newField">
        {/* header */}
        <div className="flex px-4 py-2 border-b border-[#BECBD3] items-center gap-2">
          {/* <SideArrow /> */}
          <h2 className=" w-full text-primary text-lg font-medium">{EditFieldData ? "Edit Field" : "Add Field"}</h2>
          <button className="" onClick={onClose}>
            <ClosePopUpIcn />
          </button>
        </div>

        <div className="flex flex-col font-400 text-sm  w-full gap-1 ">
          {/* <label className="text-434852 font-poppins text-sm font-normal">
                Field<span className="text-red-500">*</span>
              </label> */}
          <div className="grid grid-cols-2 gap-3 bg-[#F2F3F5] p-4  w-full border-b border-[#becbd333]">
            {options.map((option) => {
              // console.log(option, "optionabhi");
              // console.log(selectedOption, "selectedOptionabhi");

              return (
                <button
                  key={option}
                  onClick={() => handleOptionSelect(option)}
                  className={`flex items-center justify-start gap-2 border  rounded-md px-3 py-2 text-sm font-normal transition group ${EditFieldData ? "relative w-full bg-gray-200 text-gray-500 pointer-events-none opacity-60" : ""}
                    ${
                      selectedOption?.value === option?.value && selectedOption?.label === option?.label
                        ? "bg-[white] text-primary border-primary hover:border-primary "
                        : "bg-white  border-[#E3E3E3]  hover:text-primary text-[#666666]"
                    }`}
                >
                  {option?.svg && (
                    <CustomSVG
                      svg={option?.svg}
                      width="w-5"
                      height="h-5"
                      className="transition group-hover:fill-[#505E70]"
                      color={
                        selectedOption?.value === option?.value && selectedOption?.label === option?.label
                          ? "#505E70"
                          : "#8E8E8E"
                      }
                    />
                  )}
                  {/* <span className="group-hover:text-primary transition text-[#666666]  ">{option.label}</span> */}
                  <span
                    className={`transition ${
                      selectedOption?.value === option?.value && selectedOption?.label === option?.label
                        ? "text-primary"
                        : "text-[#666666] group-hover:text-primary"
                    }`}
                  >
                    {option.label}
                  </span>
                </button>
              );
            })}
          </div>

          {EditFieldData?.field_type === "dropdown" && EditFieldData?.selectedOption === "Choice" ? (
            <div className="flex justify-end mr-2 mt-3">
              {/* <div
                className="text-sm text-blue-400 font-normal cursor-pointer underline hover:text-blue-500"
                onClick={() => setIsCopyToGlobalList(true)}
              >
                Copy To Global List
              </div> */}

              <button className=" flex gap-3 items-center border p-2 rounded-md hover:bg-gray-100 w-max ">
                <span className="whitespace-nowrap text-blue-600 " onClick={() => setIsCopyToGlobalList(true)}>
                  Copy To Global List
                </span>
                <img src={icon} alt="Link Icon" className="text-gray-500 cursor-pointer" />
              </button>

              {isCopyToGlobalList && (
                <Dialog
                  open={isCopyToGlobalList}
                  onClose={handleGlobalListDialogClose}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    className: "rounded-lg p-6 max-w-sm w-full bg-white shadow-lg",
                  }}
                >
                  {/* Header */}
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-lg font-semibold text-gray-800">Copy to Global List</h2>
                    <button
                      onClick={handleGlobalListDialogClose}
                      className="text-gray-400 hover:text-gray-600 text-xl leading-none"
                    >
                      &times;
                    </button>
                  </div>

                  <div className="space-y-2 mb-6">
                    <label className="block text-gray-700 text-sm font-medium">Enter a name</label>
                    <input
                      type="text"
                      placeholder="Enter a name"
                      value={copyToGlobalListFormData.globalListname}
                      maxLength={25}
                      onChange={handleNameChange}
                      className={`h-9 px-3 border rounded-md capitalize bg-white focus:outline-hidden focus:ring-0 block w-full text-sm font-normal ${
                        isDuplicate ? "border-red-500" : "border-gray-300 focus:border-blue-500"
                      }`}
                    />
                    {isDuplicate && <p className="text-red-500 text-xs mt-1">{isDuplicate}</p>}
                  </div>

                  <div className="flex justify-end gap-3">
                    <Button onClick={handleGlobalListDialogClose} variant="secondary">
                      Cancel
                    </Button>
                    <Button onClick={handleCopyToGlobalSave} variant="primary">
                      Save
                    </Button>
                  </div>
                </Dialog>
              )}
            </div>
          ) : (
            <div>
              {selectedOption?.label === "Choice" && (
                <div className="flex items-center gap-3 justify-between border border-[#D2D2D2] p-2 mt-2 mx-4 px-2 rounded-md ">
                  <span className="text-sm font-medium text-[#313131cc]">Clone From Global List</span>

                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" checked={isCloned} onChange={handleCloneToggle} />
                    <div
                      className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-primary 
                          after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border 
                          after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"
                    ></div>
                  </label>
                </div>
              )}

              {isCloned && selectedOption?.label === "Choice" && (
                <div className="mx-4 mt-4">
                  <SelectComponent
                    options={globalDropdownData?.data}
                    labelKey="label"
                    valueKey="id"
                    name="Choose a global list "
                    onChange={handleGlobalListSelect}
                    onClick={() => {}}
                    type={"select"}
                    size={"medium"}
                    label="a Global list"
                    noFormInput
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* remaining niche ka section */}
      </div>

      {selectedOption?.label && (
        <CustomDrawer
          subDrawer
          open={selectedOption?.label}
          headerText={selectedOption?.label}
          inverseSubDrawer
          headerAction={
            <button
              className={`bg-primary text-white text-xs font-normal px-2 h-full rounded-md  ${!extraFieldData?.field_name?.trim() ? "" : ""} `}
              disabled={isEmptyOption}
              onClick={ExtraFieldSaveHeader}
            >
              Save
            </button>
          }
        >
          {" "}
          <div className=" w-full grow min-h-0 flex flex-col justify-between bg-white rounded-md shadow-md border border-[#BECBD3]">
            <div className="px-4 flex flex-col gap-4 grow min-h-0 py-2">
              {/* name */}
              <div className="flex flex-col font-400 text-sm w-full gap-1">
                <label className="text-434852 font-poppins text-sm font-normal">
                  Name<span className="text-red-500">*</span>
                </label>

                <input
                  className=" h-8 pl-2 border-[#DFE2E5] rounded-md capitalize bg-white border focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 block w-full text-sm font-normal"
                  placeholder="Enter Detail"
                  defaultValue={extraFieldData?.field_label}
                  disabled={extraFieldData?.id}
                  maxLength={25}
                  onBlur={(e) => {
                    handleFieldChange("field_label", e);
                  }}
                />
                {errors.field_label && <p className="text-red-500 text-xs mt-1">{errors.field_label}</p>}
              </div>

              {/* description */}
              <div className="flex flex-col font-400 text-sm w-full gap-1">
                <label className="text-434852 font-poppins text-sm font-normal">Description</label>
                <textarea
                  className=" bg-white border h-20 focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 text-sm font-normal  block w-full border-[#DFE2E5] rounded-md placeholder-[rgba(56,56,56,0.40)]"
                  defaultValue={extraFieldData?.field_description}
                  // className="px-4 w-full h-8 mb-1 focus:outline-none focus:ring-1 border border-CADBEB rounded-md"
                  onBlur={(e) => {
                    handleFieldChange("field_description", e);
                  }}
                  rows="8"
                  placeholder="Type Something..."
                />

                <div>
                  {selectedOption?.label == "Person" && (
                    <div className="text-535252 font-500 items-center gap-3">
                      <label className="flex pt-1 items-center ">
                        <input
                          type="checkbox"
                          id="checkbox1"
                          className="items-center appearance-none w-4 h-4 border border-[#2999BC] rounded-sm checked:border-[#2999BC] focus:outline-none focus:ring-0 checked:bg-transparent relative checked:after:content-['✔'] checked:after:text-[#2999BC] checked:after:absolute checked:after:left-[2px] checked:after:top-[-3px]"
                          checked={isMultiPerson}
                          onChange={(e) => setIsMultiPerson(e.target.checked)}
                        />

                        <span className="text-[#434852] text-sm font-normal px-1">Multi-Person</span>
                      </label>
                    </div>
                  )}
                </div>
              </div>

              {/* number */}
              {extraFieldData?.field_type !== "choice" && selectedOption?.label && <RenderNumberFormat />}

              {/* Choice */}
              {extraFieldData?.field_type === "choice" && (
                <Fragment>
                  {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                  <ChoiceField
                    setExtraFieldData={setExtraFieldData}
                    extraFieldData={extraFieldData}
                    setInputValue={setInputValue}
                    inputValue={inputValue}
                    setShadowColor={setShadowColor}
                    shadowColor={shadowColor}
                    // handleAddOption={handleAddOption}
                    setInputVisible={setInputVisible}
                    InputVisible={inputVisible}
                    allowMultiple={allowMultiple}
                    setAllowMultiple={setAllowMultiple}
                    EditFieldData={EditFieldData}
                    setIsEmptyOption={setIsEmptyOption}
                    isEmptyOption={isEmptyOption}
                    removeChoiceApi={removeChoiceApi}
                    isEditableMode={EditFieldData?.field_type ? true : false}
                    handleFieldOptionUpdate={handleFieldOptionUpdate}
                    handleFieldOptionAdd={handleFieldOptionAdd}
                  />
                </Fragment>
              )}
            </div>

            {/* <div className="border-t border-BECBD3 p-4 flex justify-end ">
              <Button
                variant="primary"
                className={`w-full ${!extraFieldData?.field_name?.trim() ? "" : ""}`}
                // disabled={!extraFieldData?.field_name?.trim()}
                disabled={isEmptyOption}
                onClick={ExtraFieldSaveHeader}
              >
                SAVE
              </Button>
            </div> */}
          </div>{" "}
        </CustomDrawer>
      )}

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={handleConfirmDelete}
          onClose={() => {
            setShowConfirmation(false);
            setChoiceToDelete(null);
          }}
          title="Delete Dropdown Option"
          message={
            <>
              You are about to delete this option from the dropdown list.
              <br />
              This change is permanent and may impact records that currently reference this option.
            </>
          }
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}
    </CustomDrawer>
  );
};

export default AddFieldDrawer;
